// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { NupayHeader } from './nupay-hearder';
import { NupayInstructions } from './nupay-instructions';

export function DisplayNupayInstructions(): Node {
  return (
    <Root>
      <NupayHeader />
      <NupayInstructions />
    </Root>
  );
}

const Root = styled.div`
  padding: 12px 0px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 0 1px rgba(63,63,68,0.05), 0 1px 3px 0 rgba(63,63,68,0.15);
`;
